import React from 'react';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { SidePage, Section, IconButton } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { BusinessPartnerFormCreate } from 'scenes/BusinessPartners/components/BusinessPartnerForm';
import { PartnerCompanyFormEdit } from 'scenes/PartnerCompanies/components/PartnerCompanyForm';
import {
  useLoadPartnerCompanyDetails,
  useIsUpdating,
} from 'scenes/PartnerCompanies/data';

import Actions from '../Actions';
import AffiliatesSection from './Sections/AffiliatesSection';
import BusinessPartnersSection from './Sections/BusinessPartnersSection';
import GeneralSection from './Sections/GeneralSection';
import MetaData from './Sections/MetaData';
import RelatedEntitiesSection from './Sections/RelatedEntitiesSection';

const PartnerCompanyDetails = ({ id, onClose, onExited, open }) => {
  const isUpdating = useIsUpdating();

  const [childComponent, openChildComponent] = useChildComponent();
  const { data, isLoading, isRefetching } = useLoadPartnerCompanyDetails(id);

  const handleEdit = () => {
    openChildComponent(PartnerCompanyFormEdit, {
      id: data.id,
    });
  };
  const handleDelete = async () => {
    onClose();
  };

  const handleAddBusinessPartners = async () => {
    openChildComponent(BusinessPartnerFormCreate, {
      partnerCompanies: data.id,
    });
  };

  const businessPartnerCount = data?.businessPartners?.length || 0;
  const affiliateCount = data?.affiliates?.length || 0;
  const relatedEntities = 1;

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating} // TODO: table row should be equal to details
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Partner Company'}
        entityId={id}
        subTitle={data?.name}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent>
          {!isEmpty(data) ? (
            <React.Fragment>
              <Section title={'General'}>
                <GeneralSection data={data} />
              </Section>
              <Section
                title={`Business Partners (${businessPartnerCount})`}
                isCollapsable={!!businessPartnerCount}
                initialOpen={false}
                action={
                  <IconButton
                    add
                    tooltip={'Add Business Partner'}
                    onClick={handleAddBusinessPartners}
                  />
                }
              >
                <BusinessPartnersSection data={data} />
              </Section>
              <Section
                title={`Affiliates (${affiliateCount})`}
                isCollapsable={!!affiliateCount}
                initialOpen={false}
              >
                <AffiliatesSection affiliates={data?.affiliates} />
              </Section>
              <Section
                title={`Related Entities (${relatedEntities})`}
                isCollapsable={true}
                initialOpen={false}
              >
                <RelatedEntitiesSection data={data} />
              </Section>
            </React.Fragment>
          ) : null}
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <Actions
              limit={3}
              data={data}
              actions={get(data, 'actions')}
              onDelete={handleDelete}
              onEdit={handleEdit}
            />
          }
        >
          <MetaData data={data} />
        </SidePage.Sidebar>
        {childComponent}
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default PartnerCompanyDetails;
